import React from 'react'
import hash from 'object-hash'
import { RegisterUserCollaboratorView, ContractView } from '../../views'
import { ClientService, Auth0Service, LocalStorageService, UserService, AddressService, ContractService, MessageService } from '../../../services'
import { ValidateInputPure, UserInvitedInformationPure, MessagePure } from '../../pures'
import { RegisterCollaboratorValidator } from '../../../validators'
import ChangePasswordAction from '../change-password/change-password.action'
import { PersonalInformation, PhoneValidation, TermsCondition } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"


/**
 * @class RegisterUserCollaboratorAction
 * @extends {React.Component}
 * @status no delete
 * @description Class describing the functinality for the registration process for user collaborator
 */
class RegisterUserCollaboratorAction extends React.Component {
    constructor(props) {
        super(props)
    }
    input = React.createRef()

    state = {
        userId: '',
        clientId: '',
        userTypeId: '',
        languageId: '',
        email: '',
        showLoadingRequesting: false,
        showCompletedRequesting: false,
        showErrorRequesting: false,
        redirectToChangePass: false,
        termnsAndConditions: false,
        contractBullets: [],
        loading: true,
        planChecked: false,
        eventId: '',
        step: 0,
        userUpdated: null,
        selectedStep: 0,
        collaboratorSteps: [
            { icon: PersonalInformation, itemElement: this.props.t('register.user.collaborator.action.personalDataTitle'), itemSup: this.props.t('register.user.collaborator.action.nextLabel'), key: 'register.personalData', labelreturn: this.props.t('register.user.collaborator.action.close'), label: this.props.t('register.user.collaborator.action.personalData') },
            { icon: PhoneValidation, itemElement: this.props.t('registration.action.validation'), itemSup: this.props.t('registration.action.Steps.nextLaber'), key: 'register.address', labelreturn: this.props.t('registration.action.Steps.backLaber'), label: this.props.t('messagePure.validation') },
            { icon: TermsCondition, itemElement: this.props.t('register.user.collaborator.action.tos'), itemSup: this.props.t('register.user.collaborator.action.nextLabel'), key: this.props.t('register.user.collaborator.action.tos'), labelreturn: this.props.t('register.user.collaborator.action.backLabel'), itemMoral: this.props.t('register.user.collaborator.action.nextLabel'), label: this.props.t('register.user.collaborator.action.tos') },
        ],
        isLastStep: false,
        logo: null,
        validationCode: '',
        oneTimePassword: '',
        validationCodeCorrect: false,
        focused: false,
    }
    collaboratorStepMetadata = [
        { number: 0, component: UserInvitedInformationPure },
        { number: 1, component: MessagePure },
        { number: 2, component: ContractView, action: 'validateContract' },
    ]
    token = {}
    user = {}
    url = process.env.REACT_APP_ETICKET_API
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()
    userService = new UserService(this.url)
    addressService = new AddressService(this.url)
    contractService = new ContractService(this.url)
    clientService = new ClientService(this.url)
    messageService = new MessageService(this.url)

    validator = RegisterCollaboratorValidator(this.props.t)

    async componentDidMount() {
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')

        let contractBullets = await this.contractService.getContractBullets(this.token)

        let userInformation = this.user.userMetaData.userA3Cloud

        await this.localStorageService.setLocalStorageItem('clientLogo', '')
        let logo = await this.fetchClientImage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

        return this.setState({
            userId: userInformation.id,
            userTypeId: userInformation.userTypeId,
            languageId: userInformation.languageId,
            clientId: userInformation.clientId,
            email: userInformation.email,
            contractBullets,
            loading: false,
            logo
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.termnsAndConditions !== this.state.termnsAndConditions) {
            if (this.state.termnsAndConditions) {
                let eventId = hash({ hash: Math.random().toString(36).substring(7) })
                this.setState({ eventId })
            }
        }
    }

    /**
     * @author Martín Sánchez
     * @description Check if the contract is selected
     * @status no delete
     */
    validateContract = async () => {
        if (!this.state.termnsAndConditions) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.collaborator.action.messagePleaseTos'))
            return false
        } else if (this.state.userTypeId === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) && !this.state.planChecked) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.collaborator.action.messageConfirm'))
            return false
        } else {
            return true
        }
    }



    /**
     * @description change the step that the user is on currently.
     * @status no delete
     * @param {*} step
     * @memberof RegisterUserCollaboratorAction
     */
    changeStepNumber = (step) => {
        let stepLenght = this.state.collaboratorSteps.length - 1
        step = (step >= stepLenght) ? stepLenght : step + 1
        return step
    }


    /**
     * @description handles back step event
     * @status no delete
     * @param {*} event
     * @memberof RegisterUserCollaboratorAction
     */
    onBackStep = async (event) => {
        event.preventDefault()
        let stepNumber = this.stepBack(this.state.selectedStep)
        this.setState({ selectedStep: stepNumber })
    }

    /**
     * @description sets the correct number and event for when user takes back step
     * @status no delete
     * @param {*} step
     * @memberof RegisterUserCollaboratorAction
     */
    stepBack = (step) => {
        if (this.state.loading && step === 0) {
            this.setState({ selectedPersonType: false })
        } else if (step === 0) {
            this.setState({ selectedPersonType: false })
            this.handleButtonLogOut()
        } else {
            step = step - 1
        }
        return step
    }

    /**
     * @description handles logout event
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
    }


    /**
    * @author Alan Aguilar
    * @description Method to show the loading dialog modal
    * @date 15-12-2020
    * @status no delete
    * @memberof RegisterUserCollaboratorAction
    */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    /**
* @author Alan Aguilar
* @description Method to show the WARNING dialog modal
* @status no delete
* @memberof SignatureRequestAction
*/
    toggleWarningRequesting = (value, message) => {
        this.setState({
            showWarningRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showWarningRequesting: false,
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the complete request dialog modal
    * @date 15-12-2020
    * @status no delete
    * @memberof RegisterUserCollaboratorAction
    */
    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCompletedRequesting: false,
                        redirectToChangePass: true
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the Error request dialog modal
    * @date 15-12-2020
    * @status no delete
    * @memberof RegisterUserCollaboratorAction
    */
    toggleErrorRequesting = (value, message) => {
        this.setState({
            showErrorRequesting: value,
            message, message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showErrorRequesting: false,
                    })
                }, 4000)
            })
    }

    async fetchClientImage() {
        let result = await this.clientService.getClientImage(this.token)
        return result?.data?.image
    }

    /**
     * @descriptions toggle terms and conditions state
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    onAcceptTermnsAndConditions = () => this.setState({ termnsAndConditions: !this.state.termnsAndConditions })

    /**
     * @description toggle accept plan state
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked })

    /**
     * @author Martín Sánchez
     * @description Close the modal after some time
     * @status no delete
     */
    onCloseOpenModal = () => this.setState({ showNotification: !this.state.showNotification })


    /**
     * @description open term and conditions modal
     * @status no delete
     * @param {*} value
     * @memberof RegisterUserCollaboratorAction
     */
    openModalTermsCond = (value) => {
        this.setState({
            modalTermsCond: value
        });
    }

    /**
     * @description handles onCloseOpenModal event
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    handleMessage = () => {
        setTimeout(() => {
            this.onCloseOpenModal()
        }, 15000);
    }
    /**
    * @author Alan Aguilar
    * @description Method to clear the localStorage and close the sesion
    * @date 15-12-2020
    * @status no delete
    * @memberof RegisterUserCollaboratorAction
    */
    onCloseSesion = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

    }

    /**
    * @author Alan Aguilar
    * @description Handle method submit to make the petition in Mifirma-api
    * @date 15-12-2020
    * @status no delete
    * @memberof RegisterUserCollaboratorAction
    */
    onSubmitRegisterUserCollaborator = async (dataItem) => {
        let selectedStep = this.state.selectedStep
        let stepNumber = this.changeStepNumber(selectedStep)
        let action = this.collaboratorStepMetadata[selectedStep].action
        let result = true
        if (action) { // Only when the submit step requires an action the result is evaluated
            result = await this[action](dataItem)
            this.handleMessage()
        }

        if (result) { // When result its ok, we can flow to next steps
            const authId = this.user.userToken && this.user.userToken.sub ? this.user.userToken.sub : '123'
            console.log(authId, 'auth0id')
            if ((selectedStep === 0)) {
                let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber

                this.setState({
                    cellphoneNumber: dataItem.cellphoneNumber
                })
                let userMetaData = await this.userService.getUser(authId, this.token.idToken)
                let userEmail = userMetaData.userA3Cloud.email
                let messageEmail = await this.messageService.sendEmailMessage(userEmail, this.token)

                if (!messageEmail) {
                    await this.toggleWarningRequesting(true, 'One time password could not be sent')
                    return false
                }
            }
            if ((selectedStep === 1)) {
                let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber
                let userMetaData = await this.userService.getUser(authId, this.token.idToken)
                let userEmail = userMetaData.userA3Cloud.email
                let validationCode = this.state.validationCode;
                let codeValidator = await this.messageService.validateEmailMessage(userEmail, validationCode, this.token)

                if (codeValidator.data === "Validated") {
                    this.setState({
                        validationCodeCorrect: true
                    })
                } else {
                    await this.toggleWarningRequesting(true, 'Teléfono o mensaje Incorrectos.')
                    return false
                }
            }

            if (selectedStep === 2 && result) { // If we are in the last step then we save the data

                try {
                    await this.toggleLoadingRequesting(true)
                    let {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        cellphoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    } = dataItem

                    let {
                        clientId,
                        userTypeId,
                        languageId,
                        email,
                        eventId,
                        termnsAndConditions
                    } = this.state


                    // Validate opcional data
                    cellphoneNumber = (cellphoneNumber === undefined || cellphoneNumber === '') ? ' ' : cellphoneNumber
                    phoneNumber = (phoneNumber === undefined || phoneNumber === '') ? ' ' : phoneNumber

                    street = (street === undefined || street === '') ? ' ' : street
                    externalNumber = (externalNumber === undefined || externalNumber === '') ? ' ' : externalNumber
                    internalNumber = (internalNumber === undefined || internalNumber === '') ? ' ' : internalNumber
                    rfc = (rfc === undefined || rfc === '') ? ' ' : rfc
                    zipCode = (zipCode === undefined || zipCode === '') ? '00000' : zipCode
                    colony = (colony === undefined || colony === '') ? ' ' : colony
                    township = (township === undefined || township === '') ? ' ' : township
                    state = (state === undefined || state === '') ? ' ' : state
                    country = (country === undefined || country === '') ? ' ' : country

                    this.token = this.localStorageService.getLocalStorageItem('token').idToken

                    // Create a new address with the data provided by the user
                    let addressUpdate = await this.addressService.createAddressInvited(street, internalNumber, externalNumber, colony, township, state, country, zipCode, email, this.token)
                    if (!(Number(addressUpdate.statusCode) === 200)) throw new Error('No se puedo completar la peticion')

                    //Update the user information and the addressId
                    let addressId = addressUpdate.data.id
                    let userData = { eventId, firstName, clientId, addressId, firstLastName, secondLastName, phoneNumber, cellphoneNumber, userTypeId, languageId, rfc, termnsAndConditions, accountId: process.env.ACCOUNT_ID }
                    let userUpdated = await this.userService.updateUser(userData, this.token)
                    this.setState({ userUpdated, isLastStep: true })
                    if (!(Number(userUpdated.statusCode) === 200)) throw new Error('No se puedo completar la peticion')

                    await this.toggleLoadingRequesting(false)
                    await this.toggleCompletedRequesting(true)
                } catch (error) {
                    await this.toggleLoadingRequesting(false)
                    await this.toggleErrorRequesting(true)
                    return false
                }
            }
            this.setState({ selectedStep: stepNumber })
        }
    }


    /**
     * @description resends code to user
     * @status no delete
     * @param {*} event
     * @memberof RegisterUserCollaboratorAction
     */
    onReSendMessage = async (event) => {
        event.preventDefault()
        let phoneNumber = this.state.cellphoneNumber
        let message = this.messageService.reSendMessage(phoneNumber, this.token)
        return message
    }

    //Button Validate input

    /**
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    handleClick = () => {
        this.input.current.focus()
    }


    /**
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    handleFocus = () => {
        this.setState({ focused: true })
    }


    /**
     * @status no delete
     * @memberof RegisterUserCollaboratorAction
     */
    handleBlur = () => {
        this.setState({
            focused: false,
        })
    }


    /**
     * @status no delete
     * @param {*} e
     * @memberof RegisterUserCollaboratorAction
     */
    handleChange = (e) => {
        const validationCode = e.target.value
        const CODE_LENGTH = new Array(6).fill(0)

        this.setState((state) => {
            if (state.validationCode.length >= CODE_LENGTH.length) return null
            return {
                validationCode: (state.validationCode + validationCode).slice(0, CODE_LENGTH.length),
            }
        })
    }


    /**
     * @description On "Backspace" key, removes a number from the validation code input
     * @status no delete
     * @param {*} e
     * @memberof RegisterUserCollaboratorAction
     */
    handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            this.setState((state) => {
                return {
                    validationCode: state.validationCode.slice(0, state.validationCode.length - 1),
                }
            })
        }
    }

    render() {
        if (this.state.redirectToChangePass === false) {

            return (
                <RegisterUserCollaboratorView
                    {...this.state}
                    validator={this.validator}
                    isLastStep={this.state.isLastStep}
                    validateInput={ValidateInputPure}
                    onSubmitRegisterUserCollaborator={this.onSubmitRegisterUserCollaborator}
                    onCloseSesion={this.onCloseSesion}
                    toggleLoadingRequesting={this.toggleLoadingRequesting}
                    toggleCompletedRequesting={this.toggleCompletedRequesting}
                    toggleErrorRequesting={this.toggleErrorRequesting}
                    toggleWarningRequesting={this.toggleWarningRequesting}
                    onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
                    stepMetadata={this.collaboratorStepMetadata}
                    steps={this.state.collaboratorSteps}
                    onChangeStep={this.onChangeStep}
                    onBackStep={this.onBackStep}
                    onSubmitClick={this.onSubmitClick}
                    onAcceptPlan={this.onAcceptPlan}
                    openModalTermsCond={this.openModalTermsCond}

                    onReSendMessage={this.onReSendMessage}
                    handleClick={this.handleClick}
                    handleFocus={this.handleFocus}
                    handleBlur={this.handleBlur}
                    handleChange={this.handleChange}
                    handleKeyUp={this.handleKeyUp}

                    input={this.input}
                    goToApp={async () => {
                        await this.toggleCompletedRequesting(true)
                    }}
                />
            )
        } else {
            return (<ChangePasswordAction
                {...this.state}
            />)
        }
    }
}


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function RegisterUserCollaboratorActionContainer(props) {
    const { t } = useTranslation()
    return (
        <RegisterUserCollaboratorAction {...props} t={t} />
    )
}


export { RegisterUserCollaboratorActionContainer as default }